import { UrlQuery } from "./UrlUtils";

export function createFiltering<F, T>(opts: {
  unpack: (r: Record<string, string | undefined>) => F;
  pack: (f: F) => Record<string, string | undefined>;
  filter: (item: T, filter: F) => boolean;
}) {
  return {
    fromUrlQuery(searchParams: UrlQuery): F {
      const f = searchParams["f"] ?? "";
      const entries = f.split(";");
      const pairs = entries.map((e) => e.split(":", 2) as [string, string]);
      const rec = Object.fromEntries(pairs);
      return opts.unpack(rec);
    },
    encode(f: F): string {
      const rec = opts.pack(f);
      const encoded = Object.entries(rec)
        .filter(([_k, v]) => !!v)
        .map(([k, v]) => k + ":" + v)
        .join(";");
      return encoded;
    },
    apply(
      items: ReadonlyArray<T>,
      f: F,
      extraFilter?: ((item: T) => boolean) | null
    ) {
      return items.filter(
        (item) => opts.filter(item, f) && (extraFilter?.(item) ?? true)
      );
    },
  };
}
